export default {
  time: {

    ranges: [{
      label: 'ui.time_ranges.last_7_days',
      value: 'last_7_days'
    }, {
      label: 'ui.time_ranges.last_14_days',
      value: 'last_14_days',
    }, {
      label: 'ui.time_ranges.last_30_days',
      value: 'last_30_days',
    }, {
      label: 'ui.time_ranges.last_60_days',
      value: 'last_60_days',
    }],

    filters: [{
      label: 'ui.day_filter.weekdays',
      value: 'weekdays'
    }, {
      label: 'ui.day_filter.weekends',
      value: 'weekends'
    }]
  }
}
